import React from 'react';

import { Action, Actions } from '@gogame/components';

const InfluencerCampaignsBulkActions = ({ rowsRows, onAddPromoCode }) => {
  return (
    <Actions>
      {/* TODO: uncomment when backend to tracking link is implemented */}
      {/*<Action*/}
      {/*  add={true}*/}
      {/*  button={true}*/}
      {/*  label={'Params to tracking link'}*/}
      {/*  onClick={() => handleAddParamsToTrackingLink(selectedRows)}*/}
      {/*/>*/}
      <Action
        border={true}
        add={true}
        button={true}
        label={'Promo Code'}
        tooltip={'Add Promo Code'}
        variant={'outlined'}
        onClick={() => onAddPromoCode(rowsRows)}
      />
    </Actions>
  );
};

export default InfluencerCampaignsBulkActions;
